import { events as mainEvents } from "@/mono/common/events";

export const events = {
  ...mainEvents,

  LOADING_OUT_COMPLETE: "loading:out_complete",

  CURSOR_HIDE: "cursor:hide",
  CURSOR_SHOW: "cursor:show",
  CURSOR_POINTER: "cursor:pointer",

  SWITCH_THEME: "switch:theme",

  GL_BACKGROUND_OPEN: "gl:background_open",
  GL_BACKGROUND_CLOSE: "gl:background_close",
  MENU_OPEN: "menu:open",
  MENU_OPEN_TRANSITION: "menu:open_transition",
  MENU_OPEN_TRANSITION_COMPLETE: "menu:open_transition_complete",
  MENU_CLOSE: "menu:close",
  MENU_OUT_COMPLETE: "menu:out_complete",

  PROJECTS_GRID_RESIZE: "projects:grid_resize",
  PROJECTS_GRID_SCROLL_TO_SERVICE: "projects:grid_scroll_to_service",

  ANIMATE_GL_BACKGROUND_IN_COMPLETE: "animate:gl_background_in_complete",
};

export const layers = {};

export const viewNames = {};

export const RENDER_ORDER = {
  PROJECT_TILES: 1,
};

export const serviceMap = {
  identity: "Identity",
  webdesign: "Webdesign",
  ["photo-video"]: "Photo & video",
  campaign: "Campaign",
  strategy: "Strategy",
};
